module.exports = __webpack_public_path__ + "img/ExpandUp.b60e32cc.svg";